import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';
import { useTheme } from '../../../../contexts/ThemeContext';

const CheckboxGroupInput = ({ value, onChange, options, style, ...props }) => {
  const { theme } = useTheme();

  return (
    <Checkbox.Group
      value={value}
      onChange={onChange}
      style={{
        color: theme.textSecondary,
        ...style,
      }}
      {...props}
    >
      {options?.map((option) => (
        <Checkbox key={option.value} value={option.value}>
          {option.label}
        </Checkbox>
      ))}
    </Checkbox.Group>
  );
};

CheckboxGroupInput.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  style: PropTypes.object,
};

export default CheckboxGroupInput; 